import { createStyles, makeStyles } from '@mui/styles';
import React from 'react';

const usePTZStyles = makeStyles(({ palette, spacing }) => {
  const sharedStyle = {
    zIndex: 6,
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  } as React.CSSProperties;

  return createStyles({
    wrapper: {
      outline: 'none !important',
      zIndex: 5,
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      cursor: 'pointer',
      '& :active': {
        cursor: 'move',
      },
      '& :focus': {
        outline: 'none',
      },
    },
    eyeball: {
      ...sharedStyle,
      width: '70px',
      height: '70px',
      borderRadius: '50%',
      background: 'transparent',
      overflow: 'hidden',
      cursor: 'no-drop',
      border: `1px solid ${palette.common.white}`,
      opacity: 0.5,
      pointerEvents: 'none',
    },
    pupil: {
      ...sharedStyle,
      width: 'auto',
      height: 'auto',
      color: palette.common.white,
    },
    navigatePointer: {
      color: palette.common.white,
    },
    zoomIndicator: {
      zIndex: 6,
      width: spacing(9),
      height: spacing(9),
      opacity: 0.5,
    },
  });
});

export default usePTZStyles;
